import React from 'react';

import './styles.css';

import { Link } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa';

import classServices from '../../../../../services/academy/classServices';

export default function ClassesCard(props) {
    async function deleteClass() {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja apagar a turma ${props.classRef}?`)) {
            const response = await classServices.deleteClass(props.id);
            if (response.status === 204) {
                props.onDelete();
                console.log(`Turma ${props.id} apagada!`);
            } else
                alert("Erro ao apagar turma, tente novamente!");
        }
    }

    return (
        <li className='classes-group-card'>
            <h4><Link to={`/${props.coachMode ? "professor" : "academia"}/turmas/${props.id}`}>{props.classRef}</Link></h4>
            <p><b>{props.type}</b></p>
            <p><b>Alunos inscritos:</b> {props.students}</p>
            {/* <p><b>Faixa etária:</b> {props.ageGroup}</p> */}
            <span className={props.vacancies ? '' : 'none'}>
                <p>
                    {
                        props.vacancies ?
                            props.vacancies + ' vagas'
                            : 'Não há vagas'
                    }
                </p>
            </span>

            {
                props.coachMode ?
                    [] :
                    <button className='delete' onClick={() => deleteClass()}><FaTrash /></button>
            }
        </li>
    )
}